// extracted by mini-css-extract-plugin
export default {"controlButton":"h4iEJm","hidden":"Xm5eRr","buttonWrapper":"k85XnN","downloadButton":"urzrNl","icon_small":"VAQcIh","iconSmall":"VAQcIh","icon_big":"R4TBlN","iconBig":"R4TBlN"};